import styled from 'styled-components';

export const Container = styled.div`
  background: inherit;
  border: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .lds-ellipsis {
    padding-bottom: 12px;
    position: relative;
    width: 80px;
    margin: auto;

  }
  .lds-ellipsis div {
    position: absolute;
    top: calc(50% - 5px);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #FFF;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .blue div {
    background: var(--light-blue);
  }
  .black div {
    background: #000;
  }
  .white div {
    background: #FFF;
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
`; 

